<template>
  <el-container>
    <el-main class="full-screen">
      <div class="detail-box">
        <el-row>
          <div class="d-left">
            <el-affix :offset="200">
              <el-row>
                <el-col :span="24" class="mt-0">
                  <el-menu
                    default-active="overview"
                    background-color="#f6faff"
                    class="el-menu-demo"
                    mode="vertical"
                    active-text-color="blue"
                    @select="scrollToElement"
                  >
                    <el-menu-item class="t2" index="OV" style="text-align:left"
                      >Overview</el-menu-item
                    >
                    <el-menu-item class="t2" index="SR"
                      >self registration</el-menu-item
                    >
                    <el-menu-item class="t2" index="GUI"
                      >Graphical User Interface</el-menu-item
                    >
                    <el-sub-menu
                      ><template #title
                        ><div class="t2">Satellites</div></template
                      >
                      <el-menu-item index="GF1">GF-1</el-menu-item>
                      <el-menu-item index="GF2">GF-2</el-menu-item>
                      <el-menu-item index="GF3">GF-3</el-menu-item>
                      <el-menu-item index="GF4">GF-4</el-menu-item>
                      <el-menu-item index="GF5">GF-5</el-menu-item>
                      <el-menu-item index="GF6">GF-6</el-menu-item>
                      <el-menu-item index="GF7">GF-7</el-menu-item>
                    </el-sub-menu>
                  </el-menu>
                </el-col>
              </el-row>
            </el-affix>
          </div>

          <div class="d-right">
            <component class="mx-5 mt-3" :is="currentcomponent"></component>
          </div>
        </el-row>
      </div>
    </el-main>

    <el-footer class="myfoot ">
      <el-row style="margin-top:50px;">
        <el-col :span="5">
          <img src="../../assets/cpeos.png" style="height:85%"
        /></el-col>

        <el-col :span="14">
          <el-row>
            <div class="ft1">LAOS DATA SERVICE HUB</div>
          </el-row>
          <el-row>
            <div class="ft2">
              Copyright © 2011-2022 CHEOS All rights reserved. 京ICP备20003293号-5 京公网安备11010502042296号&nbsp;&nbsp;&nbsp;
            </div>
          </el-row>
        </el-col>
        <el-col :span="5"> </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import selfregist from "./selfregistration.vue";
import overview from "./overview.vue";
import gui from "./gui.vue";
import gf1info from "./gf1satinfo.vue";
import gf2info from "./gf2satinfo.vue";
import gf3info from "./gf3satinfo.vue"
import gf4info from "./gf4satinfo.vue"
import gf5info from "./gf5satinfo.vue"
import gf6info from "./gf6satinfo.vue";
import gf7info from "./gf7satinfo.vue"

export default {
  components: {
    overview,
    selfregist,
    gui,
    gf1info,
    gf2info,
    gf3info,
    gf4info,
    gf5info,
    gf6info,
    gf7info
  },
  setup() {
    const state = reactive({
      currentindex: 0,
      compname: [
        "overview",
        "selfregist",
        "gui",
        "gf1info",
        "gf2info",
        "gf3info",
        "gf4info",
        "gf5info",
        "gf6info",
        "gf7info",
      ],
    });
    const scrollToElement = (index) => {
      index; // 使用菜单项的 index 作为要滚动到的元素的 ID
      if (index == "SR") state.currentindex = 1;
      if (index == "OV") state.currentindex = 0;
      if (index == "GUI") state.currentindex = 2;
      if (index == "GF1") state.currentindex = 3;
      if (index == "GF2") state.currentindex = 4;
      if (index == "GF3") state.currentindex = 5;
      if (index == "GF4") state.currentindex = 6;
      if (index == "GF5") state.currentindex = 7;
      if (index == "GF6") state.currentindex = 8;
      if (index == "GF7") state.currentindex = 9;


      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth", // 如果希望滚动过程平滑
      });
    };

    const currentcomponent = computed(() => {
      return state.compname[state.currentindex];
    });
    return {
      scrollToElement,
      currentcomponent,
      ...toRefs(state),
    };
  },
};
</script>

<style scoped>
body {
  overflow-x: hidden;
}
.myfoot {
  height: 200px !important;
  background-image: url("../../assets/footerbackground.png");
  align-items: center;
}
.full-screen {
  background: rgb(236, 236, 236);
}

.left {
  width: 200px;
  height: 500px;
}

.ft1 {
  font-size: 1.875rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 800;
  color: white;
}
.ft2 {
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: white;
}
.right {
  background: green;
  width: 600px;
  height: 900px;
}

.center-row {
  align-items: center;
}

.t1 {
  font-size: 22px; /* 设置字体大小为18像素 */
  font-weight: 700; /* 设置字体粗细为粗体 */
}
.t2 {
  font-size: 20px !important; /* 设置字体大小为18像素 */
}

.left-align-element {
  text-align: left;
}

.d-name {
  font-size: 5.2vh;
  font-family: Arial;
  font-weight: 700;
  color: #000;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 52px;
  width: 100%;
  margin-bottom: 3vh;
}

.d-left {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  background: #f6faff;
  border-radius: 24px;
  width: 287px;
}

.d-right {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-left: 40px;
  background: white;
}
.detail-box {
  padding: 40px 0;
  width: 85vw;
  margin: 0 auto;
}
.divider {
  border-top: 1px solid #ccc; /* 分割线的样式 */
  margin: 20px 0; /* 可根据需要调整上下间距 */
}
.el-menu-demo {
  text-align: left;
}
</style>
